module.exports = __webpack_public_path__ + "static/media/1.c3d1f611.jpg";